import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import jobs from '../Jobs/duck/jobsReducers';
import printers from '../Printers/duck/printersReducers';
import flowOrders from '../FlowOrders/duck/flowOrdersReducers';
import settings from '../Settings/duck/settingsReducers';
import pairingInfo from '../shared/duck/reducers/pairingInfoReducers';
import filters from '../shared/duck/reducers/filtersReducers';
import colorCard from '../ColorCard/duck/colorCardReducer';

const rootReducer = combineReducers({
    jobs,
    printers,
    flowOrders,
    settings,
    pairingInfo,
    filters,
    routing: routerReducer,
    colorCard
});

export default rootReducer;
